export const SEARCH_OWNER_DOMUS = 'SEARCH_OWNER_DOMUS'
export const IS_LOADING_FORM_OWNER_DOMUS = 'IS_LOADING_FORM_OWNER_DOMUS'
export const FORM_DATA_OWNER_DOMUS = 'FORM_DATA_OWNER_DOMUS'
